import { createEditor } from './core'
import 'prosemirror-example-setup/style/style.css'
import 'prosemirror-menu/style/menu.css'
import { insertInterpolationPlaceholder } from './core/interpolationPlaceholder'

import EditorMenu from './EditorMenu'

export default {

  name: 'KEditor',
  provide() {
    return {
      context: this,
    }
  },
  props: {
    interpolationPlaceholders: {
      type: Array,
      default() {
        return []
      },
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editorView: null,
      stateUpdateDetector: false,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    const original = this.$refs.original
    this.editorView = createEditor(original, this)
    console.log('this.editor: ', this.editorView)
  },
  methods: {
    insertInterpolationPlaceholder({ label }) {
      if (!this.editorView) {
        return
      }
      this.editorView.focus()
      return insertInterpolationPlaceholder(label, this.editorView.state, this.editorView.dispatch)
    },
  },
  render() {
    const style = {}

    const css = {
      'km-editor': true,
    }

    const attrs = {}

    const props = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <div
        {...data}
      >
        {this.$slots.header}
        <EditorMenu />
        <div
          class="km-editor__original-wrapper"
          ref="original">
        </div>
      </div>
    )
  },
}
